// libraries
import React, { useCallback, useMemo } from 'react';

// custom components
import CreateStoryForm from './CreateStoryForm';

// hooks
import useConvertedProviderCriteria from 'hooks/useConvertedProviderCriteria';
import useUploadImage from 'hooks/useUploadImage';
import useTerms from 'hooks/useTerms';

// services
import { convertCreateStoryValuesToDataLayer } from './services';

// api
import api from './api';

// utils
import { VALIDATION_TYPES } from 'utils/validation/types';
import { validate } from 'utils/validation';

const CreateStoryContainer = (): JSX.Element => {
  const { stageOptions } = useConvertedProviderCriteria(true);

  const { imageData, onChangeUploadInput } = useUploadImage();

  const { termsOfUse, privacyPolicy } = useTerms({
    isPrivacyPolicy: true,
    isTermsOfUse: true,
  });

  const onSubmit = useCallback(
    async (values: any) => {
      const convertedValues = convertCreateStoryValuesToDataLayer(
        values,
        imageData.convertedImage,
        termsOfUse,
        privacyPolicy,
      );

      await api.postStory(convertedValues);
    },
    [imageData.convertedImage, termsOfUse, privacyPolicy],
  );

  const validationSchema = useMemo(
    () => ({
      name: {
        [VALIDATION_TYPES.REQUIRED]: true,
      },
      email: {
        [VALIDATION_TYPES.REQUIRED]: true,
        [VALIDATION_TYPES.EMAIL]: true,
      },
      stage: {
        [VALIDATION_TYPES.DROPDOWN]: true,
      },
      body: {
        [VALIDATION_TYPES.REQUIRED]: true,
      },
      termsAccepted: {
        [VALIDATION_TYPES.REQUIRED]: true,
      },
    }),
    [],
  );

  const formValidation = useCallback(
    (values: any) => {
      if (values.body && values.body.length > 4000) {
        console.log('values.body.length = ', values.body.length);
        return { journey: 'too long, should be less than 4000 characters' };
      } else {
        return validate(values, validationSchema);
      }
    },
    [validationSchema],
  );

  return (
    <CreateStoryForm
      onSubmit={onSubmit}
      formValidation={formValidation}
      stageOptions={stageOptions}
      onChangeUploadInput={onChangeUploadInput}
      uploadedImageName={imageData.uploadedImageName}
    />
  );
};

export default CreateStoryContainer;
